import axios from 'axios';
import AxiosClient from '../plugins/axios';

export const createDocument = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post('iwriting/documents/en/', payload))?.data;
};

export const updateDocument = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post(`iwriting/documents/en/`, payload))?.data;
};

export const fetchDocuments = async () => {
  const client = await AxiosClient();
  return (await client.get('iwriting/documents/en/'))?.data;
};

export const fetchDocument = async (id: string) => {
  const client = await AxiosClient();
  return (await client.get(`iwriting/documents/en/${id}/`))?.data;
};

export const restoreDocument = async (id: string) => {
  const client = await AxiosClient();
  return (await client.put(`iwriting/documents/en/${id}/`, { version: 'en' } as any))?.data;
};

export const trashDocument = async (id: string) => {
  const client = await AxiosClient();
  return (await client.post(`iwriting/documents/en/${id}/`, { version: 'en' } as any))?.data;
};

export const deleteDocument = async (id: string) => {
  const client = await AxiosClient();
  return (await client.post(`iwriting/documents/en/${id}/`, { version: 'en', delete: 'permanent' } as any))?.data;
};

export const trackSession = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post(`reports/text_report/`, payload))?.data;
};

export const extractDocument = async (payload: any) => {
  return (
    await axios({
      url: `documents/extract-text`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  )?.data;
};

export const downloadDocument = async (id: string, exportText: string) => {
  if (exportText.indexOf('<p>') !== 0) {
    exportText = await convertToHTMLEntities(exportText);
  }
  return (
    await axios({
      url: `documents/export-docx?id=${id}`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: {
        text: exportText
          .replace(/<p>/gi, '<p style="line-height: 2">')
          .replace(/<li>/gi, '<li><p style="line-height: 2">')
          .replace(/<\/li>/gi, '</p></li>')
      }
    })
  )?.data;
};

const convertToHTMLEntities = async (data: any) => {
  // eslint-disable-next-line no-useless-escape
  const encodedString = data.replace(/[\u00A0-\u9999<>\&]/g, function (string: any) {
    return '&#' + string.charCodeAt(0) + ';';
  });
  return encodedString;
}


